import Loader, { LoaderType } from '../../../components/loader'
import { lazyWithRetry } from '../../../utils'
import { useClubRegistration } from '../hooks'

const ClubRegistrationMasthead = lazyWithRetry(
  () => import('../components/club_registration/ClubRegistrationMasthead')
)
const ClubRegistrationCoach = lazyWithRetry(
  () => import('../components/club_registration/ClubRegistrationCoach')
)
const ClubRegistrationValues = lazyWithRetry(
  () => import('../components/club_registration/ClubRegistrationValues')
)

const ClubRegistration: React.VFC = () => {
  const { loaded } = useClubRegistration()

  if (!loaded) return <Loader type={LoaderType.fullscreen} />

  return (
    <div className="fade">
      <ClubRegistrationMasthead />
      <ClubRegistrationCoach />
      <ClubRegistrationValues />
    </div>
  )
}

export default ClubRegistration
